module.exports = __webpack_public_path__ + "img/logo.0e9fef53.png";